import { render, staticRenderFns } from "./FestivalsMultiCategory.vue?vue&type=template&id=304397f2&scoped=true&"
import script from "./FestivalsMultiCategory.vue?vue&type=script&lang=js&"
export * from "./FestivalsMultiCategory.vue?vue&type=script&lang=js&"
import style0 from "./FestivalsMultiCategory.vue?vue&type=style&index=0&id=304397f2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304397f2",
  null
  
)

export default component.exports